import React, { Fragment, useContext } from "react";
import { useHistory } from "react-router-dom";
import { HashLink as Link } from "react-router-hash-link";

import { Container, Typography, Stack } from "@mui/material";

import Button from "@mui/material/Button";
import { componentStyles } from "../../react_utils/StyledElements";
import CharsInput from "../../react_utils/fields/CharsInput";
import { AuthContext } from "../../shared/contexts/AuthContext";
import { MessagingContext } from "../MessagingContext";
import useForgotPassword from "../../shared/hooks/settings/useForgotPassword";

export default function ForgotPassword() {
  const { apiClient } = useContext(AuthContext);
  const { showMessage } = useContext(MessagingContext);

  const { onSubmit, usernameOrEmail } = useForgotPassword(
    apiClient,
    showMessage,
  );
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Fragment>
      <Container component="main" maxWidth="xs" style={{ marginTop: 20 }}>
        <form style={componentStyles.form} noValidate onSubmit={handleSubmit}>
          <Stack direction="column" spacing={3}>
            <Typography
              color="primary"
              component="h1"
              fontSize="h5.fontSize"
              align="center"
            >
              Neue Zugangsdaten anfordern
            </Typography>
            <CharsInput
              fullWidth={true}
              placeholder="Nutzername oder E-Mail"
              onChange={(v) => {
                usernameOrEmail.setValue(v);
              }}
            />
            <Button
              type="submit"
              variant="outlined"
              style={{ color: "#efefef", borderColor: "#efefef" }}
              fullWidth
            >
              Zugangsdaten anfordern
            </Button>
            <Link to={"/"} style={{ textDecoration: "none" }}>
              <Button
                variant="outlined"
                style={{ color: "#efefef", borderColor: "#efefef" }}
                onClick={() => {
                  history.push("/");
                }}
                fullWidth
              >
                Zurück zur Startseite
              </Button>
            </Link>
          </Stack>
        </form>
        {/* </div> */}
      </Container>
    </Fragment>
  );
}

ForgotPassword.propTypes = {};
